<template>
    <div id="divRegister">
        <div class="header-nav">
            <ul class="menu">
                <li><span>{{ pageTitle }}</span></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">            
            <div id="divRegistration" v-if="!showFinalStep">
                <form @submit.prevent="createNewAccountStep1">
                    <div id="divRegistrationNumberGroup" v-if="!showStep2">
                        <div class="form-group">
                            <div class="input-group">
                                <label for="accountNumber" class="controlLabel">{{ $t("message.registrationNumber") }}</label><label class="controlLabel custom-error-message">*</label>
                                <input id="accountNumber" name="accountNumber" type="text" v-model.trim="registerData.AccountNumber" class="form-control" ref="step1RegistrationNumber" aria-required="true" />
                            </div>
                        </div>
                        <p>
                            <button type="submit" class="btn btn-sm btn-primary btn-block" @click.prevent="createNewAccountStep1()" 
                                                    :disabled="disableStep1Btn" aria-label="Next">{{ $t("message.next") }}</button>
                        </p>
                    </div>
                </form>
                <form @submit.prevent="createNewAccountStep2">
                    <div id="divRegistrationStep2" v-if="showStep2">
                        <div id="divLastName" class="form-group" v-if="showLastName">
                            <div class="input-group">
                                <label for="lastName" class="controlLabel">{{ $t("message.lastName") }}</label><label class="controlLabel custom-error-message">*</label>
                                <input id="lastName" name="lastName" type="text" v-model.trim="registerData.LastName" class="form-control" ref="step2Lastname" v-focus="true" aria-required="true" />
                            </div>
                        </div>
                        <div id="divZipCode" class="form-group">
                            <div class="input-group">
                                <label for="zipcode" class="controlLabel">{{ $t("message.zipcode") }}</label><label class="controlLabel custom-error-message">*</label>
                                <input id="zipcode" name="zipcode" type="text" v-model.trim="registerData.ZipCode" class="form-control" aria-required="true" />
                            </div>
                        </div>
                        <div id="divSubmitButton">
                            <p>
                                <button type="submit" class="btn btn-sm btn-primary btn-block" @click.prevent="createNewAccountStep2()" 
                                                        :disabled="disableStep2Btn" aria-label="Submit">{{ $t("message.submit") }}</button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
            

            <div id="divUsername" v-if="showFinalStep">
                <form @submit.prevent="createNewAccount">
                    <br />
                    <!-- Will be used in 3.0 -->
                    <div id="divAssociateMessage" class="form-group hide">
                        <div class="input-group">
                            <label class="controlLabel">{{ $t("message.addingAccountToExistingLogin") }}</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group">
                            <label for="username" class="controlLabel">{{ $t("message.newUsername") }}:
                                <span id="usernameAsEmail" v-if="registerData.EmailAsUsername" class="controlLabel custom-error-message">{{ $t("message.emailAsUsername") }}</span>
                            </label>
                            <input id="username" name="username" type="text" v-model.trim="registerData.Username" class="form-control" ref="finalStepUsername" aria-required="true" aria-describedby="usernameAsEmail" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group">
                            <label for="password" class="controlLabel">{{ $t("message.password") }}:</label>
                            <input id="password" name="password" type="password" v-model.trim="registerData.Password" class="form-control" aria-required="true" aria-describedby="passwordHelpInline" />
                            <div id="passwordHelpInline" class="helper-text" v-if="showPasswordRules">
                                <span>{{ $t("message.passwordMustContain") }}:</span>
                                <span>{{ registerData.PasswordRules }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group">
                            <label for="password2" class="controlLabel">{{ $t("message.confirmPassword") }}:</label>
                            <input id="password2" name="password2" type="password" v-model.trim="registerData.ConfirmPassword" class="form-control" aria-required="true" />
                        </div>
                    </div>
                    <p>
                        <button type="submit" class="btn btn-sm btn-primary btn-block" @click.prevent="createNewAccount()" 
                                                :disabled="disabledFinalStepBtn" aria-label="Submit">{{ $t("message.submit") }}</button>
                    </p>
                </form>
            </div>

            <ul class="custom-page-link">
                <li><router-link to="/login" class="page-link">{{ $t("message.backToLogin") }}</router-link></li>
            </ul>
        </div>        
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Register',
    data() {
        return {
            pageTitle: "Register New Account",
            registerData: {
                CustomerId: -1,
                RepId: -1,
                AccountNumber: '',
                LastName: '',
                ZipCode: '',
                Username: '',
                Password: '',
                ConfirmPassword: '',
                EmailAsUsername: false,
                PasswordRules: false
            },
            returnCustomerInfo: '',
            showStep2: false,
            showLastName: false,
            showFinalStep: false,
            extendedToastedDuration: '10000',
            defaultToastedDuration: '2000'
        }
    },
    mounted() {
        this.getRegistrationNumberIfAvailable();

        if (!this.showStep2) {
            this.$refs.step1RegistrationNumber.focus();
        } else if (this.showStep2) {
            this.$refs.step2Lastname.focus();
        } else if (this.showFinalStep) {
            this.$refs.finalStepUsername.focus();
        }
    },
    methods: {  
        getRegistrationNumberIfAvailable() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Login/GetRegistrationNumberIfAvailable?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                this.registerData.AccountNumber = response ? response : '';
            }, error => {
                console.log(error);
            });
        },     
        createNewAccountStep1() { // Step 1: Registration number
            var accountNumber = this.registerData.AccountNumber;
            if (accountNumber !== '') {
                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Login/ShowLastNameOnRegistration",
                    data: {
                        paygoAccountNumber: accountNumber
                    }
                }).then(result => {
                    var response = result.data;
                    if (response !== '' && response === true) {
                        this.showLastName = true;
                        this.showStep2 = true;                        
                    }
                }, error => {
                    console.log(error);
                })
            }
        },
        createNewAccountStep2() { // Step 2: Lastname and Zipcode
            if (this.registerData.LastName !== '' && this.registerData.ZipCode !== '') {
                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Login/SubmitRegistrationDetails",
                    data: {
                        registrationData: this.registerData
                    }
                }).then(result => {
                    var response = result.data;
                    if (response !== '') {
                        // Check for if we got a CustomerId back or not. If not, display the error message and stay on Step2
                        if (response.RegistrationData.CustomerId !== -1) {
                            // Data got validated successfully, now we can move on to the final step
                            // Save off Password Rules in our store so we can use this information for other components if needed
                            this.$store.commit('setPasswordRules', response.RegistrationData.PasswordRules);

                            this.registerData = response.RegistrationData;
                            this.showFinalStep = true;                            
                        } else {                            
                            this.showError(this.formatValidationResponseLinks(response.ValidationResult), this.extendedToastedDuration);
                        }    
                        this.showStep2 = false;                 
                    }
                }, error => {
                    console.log(error);
                })
            }
        },
        createNewAccount() { // Final step: Username and Password
            if (this.registerData.Password !== this.registerData.ConfirmPassword) {
                this.showError("Passwords do not match.", this.defaultToastedDuration);
                return;
            }

            if (this.registerData.Username.length < 4) {
                this.showError("Username must be at least 4 characters long.", this.defaultToastedDuration);
                return;
            }

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Login/ValidateAndCreateNewAccount",
                data: {
                    registrationData: this.registerData                    
                }
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    var validationResult = response.ValidationResult;
                    var redirectLink = response.RedirectLink;
                    this.registrationData = response.RegistrationData;

                    if (validationResult !== 'Success') {
                        this.showError(this.formatValidationResponseLinks(validationResult), this.extendedToastedDuration);
                        return;
                    } else {
                        // Successful login, we will go ahead and set our store 'CustomerInfo' values
                        // and set Authentication flag to true
                        var customerInfo = JSON.parse(response.CustomerInfo);
                        if (customerInfo !== '') {                      
                            this.$store.commit('setCustomerInfo', customerInfo);
                            this.$store.commit('setNavigationMenuLinks', JSON.parse(customerInfo.NavigationMenuLinks));
                            this.$store.commit('setAuthentication', true);

                            if (response.RedirectLink === "Cust_Welcome.aspx") {
                                this.$router.push({ name: "Welcome" });
                            } else {
                                this.$router.push({ name: "TermsAndConditions" });
                            }                            
                        } else {
                            this.$router.push({ name: "Login" }); 
                        }                                        
                    }
                }
            }, error => {
                console.log(error);
            })
        },
        showError(message, duration) {
            this.$toasted.show(message, {type: 'error', position: 'top-center', duration: duration});
            this.$announcer.set(message);
        },
        formatValidationResponseLinks(response) {
            // Format Portal links that we get back as part of the AJAX response, we will need to globally replace '~/' with 'Portal' keyword
            if (response.indexOf('~/') > 0) {
                return response.replace(new RegExp('~/', 'g'), this.$httpAxiosBaseUrl());
            } else {
                return response;
            }

            return '';
        }
    },
    computed: {
        disableStep1Btn() {
            return this.registerData.AccountNumber === '';
        },
        disableStep2Btn() {
            return this.registerData.LastName === '' || this.registerData.ZipCode === '';
        },
        disabledFinalStepBtn() {
            return this.registerData.Username === '' || this.registerData.Password === '' || this.registerData.ConfirmPassword === '';
        },
        showPasswordRules() {
            return this.registerData.PasswordRules !== '';
        }        
    }
}
</script>